import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { getStoredReturnUrl, navigateToReturnUrl, persistReturnUrlFromQuery } from '../../utils/returnUrl';

const useStyles = makeStyles(theme => ({
  button: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.8rem',
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    backgroundColor: '#fff',
    marginRight: '0.5em',
    flexShrink: 0,
    minWidth: 'auto',
    paddingLeft: '0.65em',
    paddingRight: '0.75em',
    '&:hover': {
      backgroundColor: '#f0f8ff',
      borderColor: theme.palette.primary.dark,
    },
  },
  buttonInCall: {
    borderColor: 'rgba(255, 255, 255, 0.85)',
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      borderColor: '#fff',
    },
  },
}));

interface ReturnToAppointmentMenuButtonProps {
  /** Dark styling for use over the video area (mobile top bar). */
  variant?: 'default' | 'in-call';
  className?: string;
}

/** Shown in the in-call menu bar when the portal passed a return URL. */
export default function ReturnToAppointmentMenuButton({
  variant = 'default',
  className,
}: ReturnToAppointmentMenuButtonProps) {
  const classes = useStyles();
  const [returnUrl, setReturnUrl] = React.useState<string | null>(null);

  React.useEffect(() => {
    persistReturnUrlFromQuery();
    const update = () => setReturnUrl(getStoredReturnUrl());
    update();
    window.addEventListener('focus', update);
    return () => window.removeEventListener('focus', update);
  }, []);

  if (!returnUrl) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      size="small"
      className={`${classes.button} ${variant === 'in-call' ? classes.buttonInCall : ''} ${className || ''}`}
      startIcon={<ArrowBackIcon />}
      onClick={() => navigateToReturnUrl()}
      data-cy-return-to-appointment-in-call
    >
      Appointment
    </Button>
  );
}
